import { PRODUCT_TYPES } from "@shared/constants/paidFeaturesHierarchy";

export const ROUTES_TO_FEATURE_FLAG_MAP_FUTURE_VISION = {
  "/app/ai": {
    getFeatureDeniedMessage: (messages: {
      menus: {
        [key: string]: { featureAccessDeniedModalTitle: string };
      };
    }) =>
      messages.menus?.[PRODUCT_TYPES.INDUSTRIAL_AI]
        .featureAccessDeniedModalTitle,
    flag: PRODUCT_TYPES.INDUSTRIAL_AI,
  },
};
